export default "__VITE_ASSET__a7592a5e__"